import React, { useState } from 'react';
import { Container, Header, Content, Footer, Divider, Loader, Panel, Row, Col, Button } from 'rsuite';
import { Link } from 'react-router-dom';
import { ChatMeTwitter} from '../components/ChatMeTwitter';
import { PrivacyLink } from '../components/PrivacyLink'
import CountryTable from '../components/CountryTable'
import useStats from '../utils/useStats';



const Card = props => {
    return (
        <Panel bordered {...props} header={props.header}>
            {props.value === null ? <Loader /> : <h2 style={{ color: props.color }}>{props.value}</h2>}
        </Panel>)
}

function Stats({ todayApi }) {
    const { stats, loading, error } = useStats(todayApi);
    if (error) return <p>Error...</p>;
    return (

        <Row className="stats-container">
            <Col sm={24} md={8}>
                <Card className="stat-card" header="Positives" color={'inherit'} value={loading ? null : stats.cases} />
            </Col>
            <Col sm={24} md={8}>
                <Card className="stat-card" header="Deaths" color={'#e84118'} value={loading ? null : stats.deaths} />
            </Col>
            <Col sm={24} md={8}>
                <Card className="stat-card" header="Recovered" color={'#4cd137'} value={loading ? null : stats.recovered} />
            </Col>
        </Row>



    )
}

export class HomeScreen extends React.Component {

    render() {
        let todayApi = 'https://coronavirus-19-api.herokuapp.com/all'
        return (
            <Container>
                <Header className="header">
                    <h1>I hate Coronavirus </h1>
                    <span className="emoji">🦠</span>

                </Header>
                <Divider />
                <Content>
                    <Stats todayApi={todayApi}></Stats>
                    <CountryTable />
                    <Row style={{ paddingTop: 40 }}>
                        <Col style={{ textAlign: 'center' }}>
                            <h3 className="medium-title">iOS user?</h3>
                            <div className="shortcut-subtitle">Get our Apple shortcuts and be updated with just a click!</div>
                            <Link  to="/shortcuts"><Button style={{marginTop: 15}} >Get it Now!</Button></Link>
                        </Col>
                    </Row>
                </Content>
                <Footer style={{ marginTop: 50, marginBottom: 50, textAlign: 'center' }}>Made with ❤️ in Italy 🇮🇹  <ChatMeTwitter /><PrivacyLink/></Footer>
            </Container>
        )
    }
}